import {AccordionButton, Box, Flex} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import NextImageUI from 'ui/NextImage';

const languages = {
  icon: '/profile-menu/change-lang.svg',
  title: {
    en: 'Languages',
    ru: 'Языки ',
    ro: 'Limbi',
  },
  needAuth: false,
};

interface IProps {
  locale?: string;
  isMenuOpen: boolean;
  onToggle: () => void;
}

export const MobileAccordionButton: FC<IProps> = ({locale, isMenuOpen, onToggle}) => {
  const currentLang = locale as 'ru' | 'ro' | 'en';

  return (
    <AccordionButton
      justifyContent="space-between"
      _hover={{bg: 'none', color: colors.pink}}
      _focus={{border: 'none'}}
      p={0}
      w="100%"
      onClick={() => onToggle()}
    >
      <NextImageUI width={32} height={32} src="/profile-menu/change-lang.svg" alt="Languages" />
      <Box flex="1" ml="15px" textAlign="left">
        {languages.title[currentLang]}
      </Box>
      <Flex transform={`rotate(${isMenuOpen ? '90deg' : '0deg'})`}>
        <NextImageUI width={24} height={24} src="/slider/arrow-icon.svg" alt="Arrow" />
      </Flex>
    </AccordionButton>
  );
};
